import { Button, Icon, InputContainer, InputText } from "@sellar-io/components";
import {
  FocusEventHandler,
  forwardRef,
  MouseEventHandler,
  useState,
} from "react";
import { twMerge } from "tailwind-merge";

type DiscoveryInputProps = {
  autoFocus?: boolean;
  initialValue?: string;
  placeholder?: string;
  inputClassName?: string;
  className?: string;
  containerClassName?: string;
  submitButtonClassName?: string;
  label?: string;
  onClick?: MouseEventHandler<HTMLInputElement>;
  onFocus?: FocusEventHandler<HTMLInputElement>;
  onSubmit: (searchValue: string) => void;
};
export const DiscoveryInput = forwardRef<HTMLInputElement, DiscoveryInputProps>(
  (
    {
      autoFocus,
      initialValue,
      placeholder = "Type a keyword...",
      inputClassName,
      className,
      containerClassName,
      submitButtonClassName,
      label,
      onClick,
      onFocus,
      onSubmit,
    },
    ref,
  ) => {
    const [searchValue, setSearchValue] = useState(initialValue ?? "");

    return (
      <form
        className={className}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(searchValue);
        }}
      >
        <InputContainer className={twMerge("pr-0", containerClassName)}>
          <InputText
            autoFocus={autoFocus}
            data-autofocus={autoFocus ? true : undefined}
            ref={ref}
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
            onClick={onClick}
            onFocus={onFocus}
            placeholder={placeholder}
            aria-label={label}
            className={twMerge("peer", inputClassName)}
          />
          {searchValue && (
            <Icon
              icon={"CLOSE"}
              className={"cursor-pointer"}
              onClick={() => {
                setSearchValue("");
                onSubmit("");
              }}
            />
          )}
          <Button
            type="submit"
            aria-label="Search"
            color="secondary"
            className={twMerge(
              "border-t-none -m-3 rounded-l-none border-y-0 border-r-0 border-gray-300 p-3",
              submitButtonClassName,
            )}
          >
            <Icon size={1} icon={"MAGNIFY"} />
          </Button>
        </InputContainer>
      </form>
    );
  },
);

DiscoveryInput.displayName = "DiscoveryInput";
